import { render, staticRenderFns } from "./CompartilhamentoDadosListagem.vue?vue&type=template&id=3ec105a0&lang=pug"
import script from "./CompartilhamentoDadosListagem.vue?vue&type=script&lang=js"
export * from "./CompartilhamentoDadosListagem.vue?vue&type=script&lang=js"
import style0 from "./CompartilhamentoDadosListagem.vue?vue&type=style&index=0&id=3ec105a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports